module.exports = __webpack_public_path__ + "img/report-lab.8241dc4f.svg";